import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import TermsAndAgreements from '@/plugins/graphql/queries/v2/terms-and-agreements.gql';
import { Getter } from 'vuex-class';
import TermsAndAgreementUpdateStatus from '@/plugins/graphql/mutations/v2/terms-and-agreement-update-status.gql';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { TermsAndAgreementModel } from '@/helpers/entities/models/TermsAndAgreementModel';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let TermsAndAgreementManager = class TermsAndAgreementManager extends Mixins(FormMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.termsAndAgreements = [];
    }
    get termsAndAgreement() {
        if (this.termsAndAgreements.length >= 1) {
            return this.termsAndAgreements[0];
        }
        return null;
    }
    toggleUpdateStatus(active, termsAndAgreementUuid) {
        this.updateTermsAndAgreement(active, termsAndAgreementUuid);
    }
    async updateTermsAndAgreement(active, termsAndAgreementUuid) {
        this.requestOnFlight();
        await this.updateActiveStatus(active, termsAndAgreementUuid)
            .then(() => {
            const msg = successfulUpdate('Terms And Agreement');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async updateActiveStatus(active, termsAndAgreementUuid) {
        if (active === null) {
            active = false;
        }
        await this.$apollo.mutate({
            mutation: TermsAndAgreementUpdateStatus,
            variables: {
                input: {
                    termsAndAgreementUuid,
                    active,
                },
            },
        });
    }
    goToTermsAndAgreementDetailsPage(uuid) {
        this.$router.push({ name: 'terms-and-agreement-edit', params: { uuid } });
    }
};
__decorate([
    Getter('appUuid')
], TermsAndAgreementManager.prototype, "appUuid", void 0);
TermsAndAgreementManager = __decorate([
    Component({
        apollo: {
            termsAndAgreements: {
                query: TermsAndAgreements,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const termsAndAgreements = data.termsAndAgreementsByApp.edges;
                    const termsAndAgreementNodes = (termsAndAgreement) => {
                        return new TermsAndAgreementModel(termsAndAgreement.node);
                    };
                    return termsAndAgreements.map(termsAndAgreementNodes);
                },
            },
        },
    })
], TermsAndAgreementManager);
export default TermsAndAgreementManager;
